import { type FC, type SVGProps } from "react";

import { CellPhoneIcon } from "@/components/icons/CellPhoneIcon";
import { DoctorIcon } from "@/components/icons/DoctorIcon";
import { HeadspaceIcon } from "@/components/icons/HeadspaceIcon";
import { Shield2 } from "@/components/icons/Shield2";
import { WaveIcon } from "@/components/icons/WaveIcon";

type IconComponentType = FC<SVGProps<SVGSVGElement>>;

export interface BenefitsItem {
  image: IconComponentType;
  imageClassName?: string;
  text: string;
  modalHeading: string;
  modalText: string;
}

export interface BenefitsData {
  heading: string;
  modalHeading: string;
  simple: string;
  buttonText: string;
  buttonTextInline: string;
  items: BenefitsItem[];
}

export const data: BenefitsData = {
  heading: "Your subscription includes:",
  modalHeading: "Complimentary subscriber benefits:",
  simple: "We're committed to supporting your growth - with more than just our supplements.",
  buttonText: "More Details",
  buttonTextInline: "See the other benefits included in your subscription.",
  items: [
    {
      image: Shield2,
      imageClassName: "md:size-6",
      text: "Results in 6 months or your money back<sup>∞</sup>",
      modalHeading: "Real Growth Guarantee",
      modalText:
        "Commit to your hair growth journey with confidence. Subscribe to your Nutrafol formula, enroll with the myNutrafol app within 30 days, complete your guided check-ins, and stay consistent for 6 months. We’ll take care of the refills, reminders, and support to help you stay consistent. And if you don’t see results? You may be eligible for a full refund. <a href='/hair/brand/support/legal/real-growth-guarantee/' target='_blank' rel='noopener noreferrer' class='underline'>Terms and conditions.</a>",
    },
    {
      image: DoctorIcon,
      text: "Wellness coaching with a naturopathic doctor",
      modalHeading: "1:1 Naturopathic Doctor Wellness Consults",
      modalText:
        "Our licensed naturopathic doctors will take the time to learn about your hair health history—then create a personalized plan with essential wellness and lifestyle advice to ensure your success.",
    },
    {
      image: WaveIcon,
      text: "Hair Mineral Analysis testing",
      modalHeading: "Hair-Mineral<br class='hidden xl:block' /> Analysis",
      modalText:
        "An in-depth lab test with a small hair sample gives us insights into what root causes may be impacting your hair so we can precisely personalize your hair growth strategy.",
    },
    {
      image: HeadspaceIcon,
      text: "A Headspace subscription",
      modalHeading: "Headspace<br class='hidden xl:block' /> Subscription",
      modalText:
        "Headspace offers access to a library of sleep, stress management, meditation tools, and more to help you reduce feelings of stress, form new habits and sleep more soundly--getting you closer to your wellness goals.",
    },
    {
      image: CellPhoneIcon,
      text: "Always-on support with myNutrafol app",
      modalHeading: "myNutrafol App",
      modalText:
        "Your ultimate hair growth partner — track progress, earn rewards, and own your journey. Unlock full access to all that your subscription has to offer: exclusive rewards, offers, tools, and education.",
    },
  ],
};
